import { createContext, use } from 'react';
export const KinderConnectCaptureContext = createContext(null);
/**
 * Returns the nearest KinderConnectCaptureContext value.
 * Must be called inside a KinderConnectCaptureContext.Provider — throws otherwise.
 *
 * @returns The context value containing the onCapture callback.
 */
export const useKinderConnectCaptureContext = () => {
    const ctx = use(KinderConnectCaptureContext);
    if (!ctx) {
        throw new Error('useKinderConnectCaptureContext must be used within a KinderConnectCaptureContext.Provider');
    }
    return ctx;
};
